<template>
    <div :id="'searchable-list-with-image-' + element.slug"
         class="searchable-list-with-image h-100 ">
        <div class="row m-0 h-100">
            <div v-if="element.media[0]"
                 class="col-12 col-lg-4 mb-3 mb-lg-0">
                <img class="image w-100" :src="this.mediaUrl" :alt="element.data.name + ' - Bild'">
            </div>
            <div class="text col-12 col-lg-8">
                <block-headline v-if="element.data.name"
                                :text="element.data.name"
                                class="text__headline"></block-headline>
                <div v-if="element.data.content"
                     class="text__content"
                     v-html="element.data.content"></div>

                <div class="link row">
                    <a v-if="element.data.linktext && element.data.linkurl"
                       class="link__text col-12 col-lg-6 mb-3 mb-lg-0"
                       href="">{{ element.data.linktext }} <i class="fad fa-chevron-right"></i>
                    </a>

                    <a v-if="element.data.file"
                       :class="element.data.linktext && element.data.linkurl ? 'd-flex justify-content-lg-end' : ''"
                       :href="'/storage' + element.data.file"
                       :title="'Download ' + element.data.headline"
                       class="link__url col-12 col-lg-6"
                       target="_blank">
                        Datei herunterladen <i class="fad fa-download ml-2"></i>
                    </a>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchableListElementWithImage',
    props: {
        element: null,
    },
    computed: {
        mediaUrl() {
            return '/storage' + this.element.media[0].path + '/' + this.element.media[0].file_name;
        },
    },
};
</script>
